<template>
  <div class="checkout-item">
    <h5 class="prod-name">{{ prod.name }}</h5>
    <div
      v-for="(op, indexOp) in prod.options"
      :key="indexOp"
      class="model-container"
    >
      <v-container fluid>
        <v-layout wrap v-if="isMobile()">
          <v-flex xs3>
            <img :src="op.image" width="50px" height="50px" />
          </v-flex>
          <v-flex xs9>
            <h5 class="option-name">{{ op.name }}</h5>
            <div class="price-content">
              <BandAid
                class="bandaid"
                :quantity="op.quantity"
                @plusQuantity="innerPlusQuantity(indexOp)"
                @lessQuantity="innerLessQuantity(indexOp)"
              />
              <h5 class="price">$ {{ op.quantity * op.unitPrice }}</h5>
            </div>
          </v-flex>
        </v-layout>

        <v-layout wrap v-else>
          <v-flex xs3>
            <img :src="op.image" width="80px" height="80px" />
          </v-flex>
          <v-flex xs7>
            <h5 class="option-name">{{ op.name }}</h5>
            <BandAid
              :quantity="op.quantity"
              @plusQuantity="innerPlusQuantity(indexOp)"
              @lessQuantity="innerLessQuantity(indexOp)"
            />
          </v-flex>
          <v-flex xs2>
            <h5 class="price">$ {{ op.quantity * op.unitPrice }}</h5>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import mobile_detection from "../mixins/mobile_detection";
import BandAid from "./BandAid";

export default {
  mixins: [mobile_detection],
  name: "CheckoutItem",
  props: {
    prod: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    innerPlusQuantity(indexOp) {
      let prods = this.$store.getters.getSelectedProducts;

      prods[this.index].options[indexOp].quantity++;

      this.$store.commit("SET_SELECTED_PRODUCTS", prods);
    },
    innerLessQuantity(indexOp) {
      let prods = this.$store.getters.getSelectedProducts;

      prods[this.index].options[indexOp].quantity--;

      if (prods[this.index].options[indexOp].quantity === 0) {
        prods[this.index].options.splice(indexOp, 1);
        if (prods[this.index].options.length === 0) {
          prods.splice(this.index, 1);
        }
      }

      this.$store.commit("SET_SELECTED_PRODUCTS", prods);
    },
  },
  components: {
    BandAid,
  },
};
</script>


<style scoped>
.option-name {
  font-size: 14px;
  margin-right: 1vw;
}
.option-container {
  width: 12vw;
  margin-left: 1em;
}
.checkout-item {
  border-bottom-style: solid;
  border-color: darkgray;
  border-width: thin;
  background-color: rgba(95, 106, 121, 0.06);
  margin: 1em;
  padding: 0.7em;
  border-radius: 5px;
}
.model-item {
  display: inline-flex;
  width: 100%;
  margin: 0.5em;
}
.container {
  padding: 6px;
}
.prod-name {
  font-size: 16px;
  font-weight: 800;
}
.price {
  min-inline-size: max-content;
}

@media only screen and (max-width: 743px) {
  .prod-name {
    font-size: 14px;
  }
  .option-name {
    font-size: 11px;
  }
  .price {
    font-size: 14px;
    width: 100%;
    text-align: right;
  }
  .price-content {
    display: inline-flex;
    width: 100%;
  }
  .bandaid {
    margin-right: 10px;
  }
}
@media only screen and (min-width: 743px) and (max-width: 1600px) {
  .model-container {
    width: 22em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CheckoutItem.vue